import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: process.env.SENTRY_TEAM_JS_DSN,
    release: process.env.SENTRY_RELEASE !== '' ? process.env.SENTRY_RELEASE : 'main',
    environment: process.env.NODE_ENV,
    integrations: [
        // Sentry.browserTracingIntegration(),
        // Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
        }),
        // Sentry.replayCanvasIntegration(),
    ],

    attachStacktrace: true,

    // Performance Monitoring
    tracesSampleRate: 0.05,
    // tracePropagationTargets: ["localhost", /^https:\/\/sentry\.autotrade\.su\/api/],
    // profilesSampleRate: 0.0001,

    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
});
